import {
  Home,
  AboutUs,
  Contact,
  NewsEvent,
  NewsEventReadMore,
  Products,
  Policy,
} from '../screens';

export default [
  {
    label: 'Home',
    showMenu: false,
    component: Home,
    to: '/',
  },
  {
    label: 'About us',
    showMenu: true,
    component: AboutUs,
    to: '/about-us',
  },
  {
    label: 'Products',
    showMenu: true,
    component: Products,
    to: '/products',
  },
  {
    label: 'News & Event',
    showMenu: true,
    component: NewsEvent,
    to: '/news-event',
  },
  {
    label: 'News & Event',
    showMenu: false,
    component: NewsEventReadMore,
    exact: false,
    to: '/news-event/:id',
  },
  {
    label: 'Contact',
    showMenu: true,
    component: Contact,
    to: '/contact',
  },
  {
    label: 'Policy',
    showMenu: true,
    component: Policy,
    to: '/policy',
  },
];



// WEBPACK FOOTER //
// ./src/routes/index.js